import { render, staticRenderFns } from "./CurrentIdentifications.vue?vue&type=template&id=333f9fb3&scoped=true"
import script from "./CurrentIdentifications.vue?vue&type=script&lang=js"
export * from "./CurrentIdentifications.vue?vue&type=script&lang=js"
import style0 from "./CurrentIdentifications.vue?vue&type=style&index=0&id=333f9fb3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "333f9fb3",
  null
  
)

export default component.exports